import { AcumaticaRequestOptions, AcumaticaService } from '../acumatica.service';
import { AcumaticaEntity, AcumaticaEntityService } from './acumatica-entity';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Acumatica } from '../acumatica-field-decorator';

@Injectable({
    providedIn: 'root'
})
export class ItemClassService extends AcumaticaEntityService {
    constructor(acumatica: AcumaticaService) {
        super(acumatica, 'ItemClass', ItemClass);
    }

    get(ItemClassID: string, options: AcumaticaRequestOptions = {}): Observable<ItemClass> {
        return super.getEntity(ItemClassID, {
            ...{ message: "Getting Item Class" },
            ...options
        });
    }
}

export class ItemClass extends AcumaticaEntity {
    @Acumatica() ClassID?: string;
    @Acumatica() Description?: string;
    @Acumatica() BaseUOM?: string;
    @Acumatica() SalesUOM?: string;
    @Acumatica() PurchaseUOM?: string;
    @Acumatica() DefaultWarehouseID?: string;
    @Acumatica() LotSerialClass?: string;
}